import isEmpty from "lodash/isEmpty";
import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  order: {
    itemCount: 0,
    id: null,
    number: null,
    items: [],
  },
  orderFetched: false,
  orderFetching: true,
  isCartUpdating: false,
};

const updateItems = (items, newItems) => {
  if (isEmpty(newItems)) return items;

  return newItems.map((lineItem) => ({
    ...items.find(({ id: lineItemId }) => lineItemId === lineItem.id),
    ...lineItem,
  }));
};

const updateOrder = (state, { payload }) => {
  const { lineItems, medleyItemSets, productSets, ...otherOrderAttributes } = state.order;
  const {
    lineItems: newLineItems,
    medleyItemSets: newMedleyItemSets,
    productSets: newProductSets,
  } = payload;
  return {
    ...otherOrderAttributes,
    ...payload,
    lineItems: isEmpty(lineItems) ? newLineItems : updateItems(lineItems, newLineItems),
    medleyItemSets: isEmpty(medleyItemSets)
      ? newMedleyItemSets
      : updateItems(medleyItemSets, newMedleyItemSets),
    productSets: isEmpty(productSets) ? newProductSets : updateItems(productSets, newProductSets),
  };
};

const syncReducers = {
  setIsCartUpdating: (state, { payload }) => {
    state.isCartUpdating = payload;
  },
  setCart: (state, { payload }) => {
    return {
      order: payload,
      orderFetched: false,
      orderFetching: !!payload.id,
      isCartUpdating: state.isCartUpdating,
    };
  },
  updateCart: (state, { payload }) => {
    return {
      order: payload,
      orderFetched: true,
      orderFetching: false,
      isCartUpdating: state.isCartUpdating,
    };
  },
  updateCartOrder: (state, { payload }) => {
    return {
      ...state,
      order: { ...state.order, ...payload },
      orderFetching: false,
      isCartUpdating: state.isCartUpdating,
    };
  },
  emptyCart: () => {
    return { ...INITIAL_STATE, orderFetching: false };
  },
  resetCart: () => {
    return INITIAL_STATE;
  },
  updateOrderAttributes: (state, { payload }) => {
    return {
      ...state,
      order: updateOrder(state, { payload }),
    };
  },
};

const cart = createSlice({
  name: "cart",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const {
  emptyCart,
  setCart,
  updateCart,
  resetCart,
  updateCartOrder,
  updateOrderAttributes,
  setIsCartUpdating,
} = cart.actions;

export default cart.reducer;
